// ============================================
// FILE: lib/socket.js
//
// Single shared socket instance for the whole app.
// Import { socket } wherever you need it.
// ============================================

import { io } from 'socket.io-client';

const URL = 'https://demo-api-384317551782.europe-west1.run.app' || 'http://localhost:3001';

export const socket = io(URL, {
  transports: ['websocket', 'polling'],
  autoConnect: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

// Optional: debug in dev only
if (import.meta.env.DEV) {
  socket.on('connect',    ()      => console.log('[socket] connected:', socket.id));
  socket.on('disconnect', (reason) => console.log('[socket] disconnected:', reason));
  socket.on('connect_error', (err) => console.error('[socket] error:', err.message));
}